import { Fragment, useEffect, useState } from "react";
import { Stack } from "../../FormControls/Stack";
import { Text } from "../../FormControls/Text";
import { Button } from '../../FormControls/Button';
import { ScreenControl } from "../ScreenControl";
import { updateInvoice } from "../../../../main/slices/storeSlice";
import { jump } from "../../../../main/slices/routerSlice";
import { useDispatch, useSelector } from "react-redux";
import { InfoOutlined, ArrowBackIos } from "@mui/icons-material";

export const TimeOut = ({ dimensions }) => {
  let infoStatus = [];
  const dispatch = useDispatch();
  const stateTrx = useSelector(({ transaction }) => transaction);
  const userState = useSelector(({ user }) => user);
  const storeInfo = useSelector(({ store }) => store);
  const currentDate = new Date();

  // Opciones para formatear la fecha
  const options = {
    weekday: "long", // Día de la semana completo (martes)
    day: "2-digit", // Día con dos dígitos (10)
    month: "long", // Nombre completo del mes (diciembre)
    year: "numeric", // Año (2024)
    timeZone: "GMT", // Asegura que sea en GMT
  };
  // Formatear la fecha
  const dateFormat = currentDate.toLocaleDateString("es-ES", options);

  // COPY TEXT
  const [copySuccess, setCopySuccess] = useState(false);
  const textToCopy = "copiar";

  // const coupons = userState.paymentType.value === "COUPON";
  infoStatus = [
    { label: "Fecha", value: dateFormat },
    { label: "Código de Referencia", value: stateTrx.reference.value },
    { label: "DPI", value: userState.dpi.value },
    {
      label: "Monto",
      value: `${parseFloat(stateTrx.total.value).toFixed(2)} Quetzales`,
    }, // CONTEMPLAR RESTO DE MONEDAS LUEGO
  ];

  function copyText(){
    if (navigator.clipboard) {
        // Usamos la API de portapapeles
        navigator.clipboard
          .writeText(userInfo.discountCode.value)
          .then(() => {
            setCopySuccess(true); // Confirmamos que la copia fue exitosa
            setTimeout(() => setCopySuccess(false), 2000); // Reiniciamos el estado después de 2 segundos
          })
          .catch((err) => {
            console.error("Error al copiar al portapapeles: ", err);
            setCopySuccess(false); // Si hay un error, mostramos el mensaje
          });
      }
  }

  useEffect(() => {
    const updTrx = async (trxStatus) => {
      return await dispatch(updateInvoice({
        "status": "Expired",
        "trxId": `${stateTrx.idTransaction.value}`,
        "store": `${storeInfo.idStore.value}`
      })).unwrap()
          .then(({ response }) => {
            return true;
          })
          .catch(e => {
            return false
          });
    };
    
    updTrx();
  }, [dispatch]);

  return (
    <Fragment>
      <div style={{ padding: "0 1.5rem" }}>
        {/* SCREEN LEGENDS */}
        <Stack flex={{ flexDirection: "Column" }}>
          <div style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
          <InfoOutlined
            sx={{ fontSize: "10em", margin: "0 0.5em", color: "#f7bf3e" }}
          />
          </div>
          <Text
            classes={["tittle"]}
            style={{
              fontWeight: "bold",
              color: "#f7bf3e",
              alignItems: "center",
              textAlign: "center",
              fontSize: '1.25em'
            }}
          >
            {
              "Transacción Finalizada"
            }
          </Text>
          <div style={{ marginBottom: "2rem" }}></div>
          <Text
            classes={["center"]}
            style={{
              fontSize: '0.8em'
            }}
          >
            {""}
              Lo sentimos, se ha agotado el tiempo para completar tu pago. Recuerda que puedes generar una nueva transacción desde el panel WORLDPOS.
            {""}
          </Text>
          <div style={{ marginBottom: "4rem" }}></div>
          <Text
            classes={["tittle", "center"]}
            style={{
              fontWeight: "bold",
              color: "rgba(108, 133, 137, 1)",
              alignItems: "center",
              textAlign: "center",
              fontSize: '2em'
            }}
          >
          </Text>
        </Stack>
      </div>
      <Button 
          style={{
              position: "fixed",
              top: "1.5rem",
          }} 
          classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
          onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }
      >
        <ArrowBackIos />
      </Button>
      <ScreenControl 
        showGoBack={false}
        btnText={"Volver al Inicio"}
        index={{ fw: 8 }}
        disabled={false} 
      ></ScreenControl>
    </Fragment>
  );
};
